import { Button } from "@nextui-org/react";
import React from "react";

import Trans from "@/components/Trans/Trans";

import { Text } from "../customComponents";
import CardIcon from "./CardIcon";
import { CreditCardSummaryProps } from "./types";

const CreditCardSummary = ({ last_4, type, exp, onChangeButtonClick }: CreditCardSummaryProps) => {
  return (
    <>
      <Text variant={"regular"} type={"font-[600]"}>
        <Trans i18nKey="subscription:checkout.creditCard.heading" />
      </Text>

      <div className="flex flex-row items-center justify-between">
        {" "}
        {/* Added justify-between for right alignment */}
        <div className="flex items-center gap-2">
          <CardIcon className="mt-2" width={40} brand={type} />
          <span className="text-sm font-semibold">
            <Trans i18nKey="subscription:checkout.creditCard.cardDetails" values={{ last4: last_4, exp }} />
          </span>
        </div>
        <span className="text-sm font-semibold">
          <Button radius="full" variant="bordered" onClick={() => onChangeButtonClick(true)} aria-label="annual">
            <Trans i18nKey="subscription:checkout.creditCard.change" />
          </Button>
        </span>
      </div>
    </>
  );
};

export default CreditCardSummary;
